import 'css-chunksrc/client/scenes/notifications/notification/date/styles.scss';export default {
  "date": "_date_5jsea_1"
};